import { Card } from 'antd';
import React, { useState, useEffect } from 'react';
import { ReactToPrint } from 'react-to-print';
import { Button, TextField } from "@mui/material";
import config from "../../config.js";

const Print = ({complaintId}) => {
  let componentRef = React.createRef();
  const [combinedData, setCombinedData] = useState([]);
  const fetchData = async () => {
    try {
      const response = await fetch(`${config.BASE_URL_IP}/wob/Techinician-form/${complaintId}`, {
        method: "GET", 
        headers: { "Content-Type": "application/json"},  
      });
      const jsonData = await response.json();
      setCombinedData(jsonData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [complaintId]);

  return (
    <Card>
    <div>
      <ReactToPrint
        trigger={() => {
          return <Button 
          variant="contained"
          color="success">Print</Button>
        }}
        content={() => componentRef.current}
        documentTitle='`'
        pageStyle='Print'
        onAfterPrint={() => {
          console.log('Printed');
        }}
      />
      <div ref={componentRef}>
        <div>
          <h3 style={{ fontWeight: 'bold', textAlign: 'center' }}>NATIONAL INSTITUTE OF TECHNICAL TEACHERS TRAINING AND RESEARCH</h3>
          <p style={{ textAlign: 'center' }}>Taramani, Chennai-600113</p>
          <br />
          <br />
          {combinedData.map(todo => {
            const correspondingTable1Data = combinedData.find(data => data.complaint_id === todo.complaint_id);
            const workCompletionDate = correspondingTable1Data ? correspondingTable1Data.work_completion_date != null ? new Date(correspondingTable1Data.work_completion_date).toLocaleDateString() : null : null;
            const complaintRaiseDate = correspondingTable1Data ? correspondingTable1Data.complaint_raise_date != null ? new Date(correspondingTable1Data.complaint_raise_date).toLocaleDateString() : null : null;
            const directorApprovalDate = correspondingTable1Data ? correspondingTable1Data.approved_by_director_date != null ? new Date(correspondingTable1Data.approved_by_director_date).toLocaleDateString() : null : null;
            const workAssignedDate = correspondingTable1Data ? new Date(correspondingTable1Data.work_assigned_date) : null;
            const correspondingTable2Data = combinedData.find(data => data.complaint_id === todo.complaint_id);
            if (!correspondingTable2Data) {
              return null; // Skip rendering if there's no corresponding data in table2Data
            }
            if(correspondingTable2Data.complaint_type_id === 1 )
            {
            return (
              <div key={todo.complaint_id}>
            {/* <h3 style={{ textAlign: 'center' }}>ELECTRICAL MAINTENANCE</h3> */}
            <h3 style={{ textAlign: 'center' }}>{correspondingTable2Data.title}</h3>
            <br />
              <div style={{ textAlign: 'center' }}>
                <h4 style={{ textDecoration: 'underline' }}>WORK ORDER FORM</h4>
                <div style={{ textAlign: 'right', marginRight: '100px'}}>
                  {/* Replace 'dateValue' with the actual value */}
                  <p>Date: {complaintRaiseDate}</p>
                  <p>Work Order No: {todo.work_order_id}</p>
                </div>
              </div>
            <br />
            <p>Name of the Department/Quarters No : {correspondingTable1Data.department}</p>
            <br></br>
            <p>The following works mentioned below may kindly be arranged to be undertaken</p>
            <br></br>
                  <p>{correspondingTable2Data.body}</p>
                  <br></br>
                  <br></br>
                  <div style={{ textAlign: 'right' , marginRight: '100px'}}>
                    {/* Replace 'nameValue', 'signatureValue', and 'deptNoValue' with the actual values */}
                    <p>Name:{correspondingTable1Data.user_name}</p>
                    <p>Dept/Quarters No: {correspondingTable1Data.department}</p>
                  </div>
                  <br></br>
                  <hr></hr>
                  <br></br>
                  <p style={{ fontWeight: "bold"}}>Approval of the Director:</p>
                  <p style={{textAlign: "center"}}> Approved on {directorApprovalDate}</p>
                  <br></br>
                  <hr></hr>
                  <br></br>
                  <p>Job completed satisfactorily on {workCompletionDate}</p>
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                      <p style={{ marginRight: '76px' }}>Name:{correspondingTable1Data.user_name}</p>
                      <p style={{ marginRight: '76px' }}>Dept/qrts No: {correspondingTable1Data.department}</p>
                    </div>
                  </div>
                  <br></br>
                  <br></br>
                  <hr></hr>
                  <br></br>
                  <h4 style={{fontWeight: 'bold', textAlign: 'center'}}>FOR DEPARTMENT USE ONLY</h4>
                  <br></br>
                  <p>Work Order No <span style={{marginLeft: '100px'}}>:</span>{todo.work_order_id}</p>
                  <br></br>
                  <p>Date of issue <span style={{marginLeft: '115px'}}>:</span>{workAssignedDate.toLocaleDateString()}</p>
                  <br></br>
                  <p>Materials Used <span style={{marginLeft: '100px'}}>:</span></p>
                  <TextField
                            label=""
                            fullWidth
                            multiline
                            rows={5}
                            variant="outlined"
                            margin="normal"
                        />
                  <p>Date of completion <span style={{marginLeft: '73px'}}>: {workCompletionDate}</span></p>
                  <br></br>
                  <br></br>
                  <p>Technician <span style={{marginLeft: '125px'}}>: {correspondingTable1Data.technician_id}</span></p>
                  <br></br>
                  <br></br>
                  <p style={{fontWeight:'bold'}}>J.E-ELECTRICAL <span style={{marginLeft:'300px'}}>O.L.C ELECTRICAL MAINTENANCE</span></p>
                </div>
              );}

              else if(correspondingTable2Data.complaint_type_id === 2)
              {
                return (
                  <div key={todo.complaint_id}>
                {/* <h3 style={{ textAlign: 'center' }}>ELECTRICAL MAINTENANCE</h3> */}
                <h3 style={{ textAlign: 'center' }}>{correspondingTable2Data.title}</h3>
                <br />
                  <div style={{ textAlign: 'center' }}>
                    <h4 style={{ textDecoration: 'underline' }}>WORK ORDER FORM</h4>
                    <div style={{ textAlign: 'right', marginRight: '100px'}}>
                      {/* Replace 'dateValue' with the actual value */}
                      <p>Date: {complaintRaiseDate}</p>
                      <p>Work Order No: {todo.work_order_id}</p>
                    </div>
                  </div>
                <br />
                <p>Name of the Department/Quarters No :{correspondingTable1Data.department}</p>
                <br></br>
                <p>The following works mentioned below may kindly be arranged to be undertaken</p>
                <br></br>
                      <p>{correspondingTable2Data.body}</p>
                      <br></br>
                      <br></br>
                      <div style={{ textAlign: 'right' , marginRight: '100px'}}>
                        {/* Replace 'nameValue', 'signatureValue', and 'deptNoValue' with the actual values */}
                        <p>Name: {correspondingTable1Data.user_name}</p>
                        <p>Dept/Quarters No: {correspondingTable1Data.department}</p>
                      </div>
                      <br></br>
                      <hr></hr>
                      <br></br>
                      <p style={{ fontWeight: "bold"}}>Approval of the Director:</p>
                      <p style={{textAlign: "center"}}> Approved on {directorApprovalDate}</p>
                      <br></br>
                      <hr></hr>
                      <br></br>
                      <p>Job completed satisfactorily on {workCompletionDate}</p>
                      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                          <p style={{ marginRight: '120px' }}>Name: {correspondingTable1Data.user_name}</p>
                          <p style={{ marginRight: '76px' }}>Dept/qrts No: {correspondingTable1Data.department}</p>
                        </div>
                      </div>
                      <br></br>
                      <br></br>
                      <hr></hr>
                      <h4 style={{fontWeight: 'bold', textAlign: 'center'}}>FOR DEPARTMENT USE ONLY</h4>
                      <p>Work Order No <span style={{marginLeft: '100px'}}>:</span>{todo.work_order_id}</p>
                      <br></br>
                      <p>Date of issue <span style={{marginLeft: '115px'}}>:</span>{workAssignedDate.toLocaleDateString()}</p>
                      <br></br>
                      <p>Materials Used <span style={{marginLeft: '100px'}}>:</span></p>
                      <TextField
                            label=""
                            fullWidth
                            multiline
                            rows={6}
                            variant="outlined"
                            margin="normal"
                        />
                      <p>Date of completion <span style={{marginLeft: '73px'}}>: {workCompletionDate}</span> </p>
                      <br></br>
                      <br></br>
                      <p>Technician <span style={{marginLeft: '125px'}}>:</span>{correspondingTable1Data.technician_id}</p>
                      <br></br>
                      <br></br>
                      <p style={{fontWeight:'bold'}}>CONSULTANT - ESTATE<span style={{marginLeft:'350px'}}>ESTATE OFFICER</span></p>
                    </div>
                  );
              }

              else if(correspondingTable2Data.complaint_type_id === 4)
              {
                return (
                  <div key={todo.complaint_id}>
                {/* <h3 style={{ textAlign: 'center' }}>ELECTRICAL MAINTENANCE</h3> */}
                <h3 style={{ textAlign: 'center' }}>{correspondingTable2Data.title}</h3>
                <br />
                  <div style={{ textAlign: 'center' }}>
                    <h4 style={{ textDecoration: 'underline' }}>WORK ORDER FORM</h4>
                    <div style={{ textAlign: 'right', marginRight: '100px'}}>
                      {/* Replace 'dateValue' with the actual value */}
                      <p>Date: {complaintRaiseDate}</p>
                      <p>Work Order No: {todo.work_order_id}</p>
                    </div>
                  </div>
                <br />
                <p>Name of the Department/Quarters No :{correspondingTable1Data.department}</p>
                <br></br>
                <p>The following works mentioned below may kindly be arranged to be undertaken</p>
                <br></br>
                      <p>{correspondingTable2Data.body}</p>
                      <br></br>
                      <br></br>
                      <div style={{ textAlign: 'right' , marginRight: '100px'}}>
                        {/* Replace 'nameValue', 'signatureValue', and 'deptNoValue' with the actual values */}
                        <p>Designation: </p>
                      </div>
                      <br></br>
                      <hr></hr>
                      <br></br>
                      <p style={{ fontWeight: "bold"}}>Approval of the Director:</p>
                      <p style={{textAlign: "center"}}> Approved on {directorApprovalDate}</p>
                      <br></br>
                      <hr></hr>
                      <br></br>
                      <h4 style={{fontWeight: 'bold', textAlign: 'center'}}>FOR DEPARTMENT USE ONLY</h4>
                      <br></br>
                      <p>Configuration / Details of the equipment recieved:</p>
                      <br></br>
                      <p>Materials Used <span style={{marginLeft: '100px'}}>:</span></p>
                      <TextField
                            label=""
                            fullWidth
                            multiline
                            rows={3}
                            variant="outlined"
                            margin="normal"
                        />
                      <br></br>
                      <p>Work carried out: </p>
                      <TextField
                            label=""
                            fullWidth
                            multiline
                            rows={3}
                            variant="outlined"
                            margin="normal"
                        />
                      <p style={{fontWeight:'bold', textAlign: "right"}}>Officer in-charge</p>
                      <p style={{fontWeight:'bold', textAlign: "right"}}>System Maintenance</p>
                      <br></br>
                      <hr></hr>
                      <br></br>
                      <p>Job completed satisfactorily on {workCompletionDate} and the above components were replaced</p>
                      <br></br>
                      <p style={{textAlign:"center"}}>Department {correspondingTable1Data.department}</p>
                    </div>
                  );
              }

              else if(correspondingTable2Data.complaint_type_id === 5)
              {
                return (
                  <div key={todo.complaint_id}>
                {/* <h3 style={{ textAlign: 'center' }}>ELECTRICAL MAINTENANCE</h3> */}
                <h3 style={{ textAlign: 'center' }}>{correspondingTable2Data.title}</h3>
                <br />
                  <div style={{ textAlign: 'center' }}>
                    <h4 style={{ textDecoration: 'underline' }}>WORK ORDER FORM</h4>
                    <div style={{ textAlign: 'right', marginRight: '100px'}}>
                      {/* Replace 'dateValue' with the actual value */}
                      <p>Date: {complaintRaiseDate}</p>
                      <p>Work Order No: {todo.work_order_id}</p>
                    </div>
                  </div>
                <br />
                <p>Name of the Department/Quarters No  {correspondingTable1Data.department}:</p>
                <br></br>
                <p>The following works mentioned below may kindly be arranged to be undertaken</p>
                <br></br>
                      <p>{correspondingTable2Data.body}</p>
                      <br></br>
                      <br></br>
                      <div style={{ textAlign: 'right' , marginRight: '100px'}}>
                        {/* Replace 'nameValue', 'signatureValue', and 'deptNoValue' with the actual values */}
                    
                        <p>Designation: </p>
                      </div>
                      <br></br>
                      <hr></hr>
                      <br></br>
                      <p style={{ fontWeight: "bold"}}>Approval of the Director:</p>
                      <p style={{textAlign: "center"}}> Approved on {directorApprovalDate}</p>
                      <br></br>
                      <hr></hr>
                      <br></br>
                      <h4 style={{fontWeight: 'bold', textAlign: 'center'}}>FOR DEPARTMENT USE ONLY</h4>
                      <br></br>
                      <p>Configuration / Details of the equipment recieved:</p>
                      <br></br>
                      <p>Materials Used <span style={{marginLeft: '100px'}}>:</span></p>
                      <TextField
                            label=""
                            fullWidth
                            multiline
                            rows={3}
                            variant="outlined"
                            margin="normal"
                        />
                      <br></br>
                      <p>Work carried out: </p>
                      <TextField
                            label=""
                            fullWidth
                            multiline
                            rows={3}
                            variant="outlined"
                            margin="normal"
                        />
                      <br></br>
                      <br></br>
                      <br></br>
                      <p style={{fontWeight:'bold'}}>Technician<span style={{marginLeft:"250px"}}>Technical asst</span><span style={{marginLeft:"250px"}}>HOD</span></p>
                      <br></br>
                      <hr></hr>
                      <br></br>
                      <p>Job completed satisfactorily on {workCompletionDate} and the above components were replaced</p>
                      <br></br>
                      <br></br>
                      <br></br>
                      <p style={{textAlign:"center"}}>Department {correspondingTable1Data.department}</p>
                    </div>
                  );

              }

              else if(correspondingTable2Data.complaint_type_id === 3)
              {
                return (
                  <div key={todo.complaint_id}>
                {/* <h3 style={{ textAlign: 'center' }}>ELECTRICAL MAINTENANCE</h3> */}
                <h3 style={{ textAlign: 'center' }}>{correspondingTable2Data.title}</h3>
                <br />
                  <div style={{ textAlign: 'center' }}>
                    <h4 style={{ textDecoration: 'underline' }}>WORK ORDER FORM</h4>
                    <div style={{ textAlign: 'right', marginRight: '100px'}}>
                      {/* Replace 'dateValue' with the actual value */}
                      <p>Date: {complaintRaiseDate}</p>
                      <p>Work Order No: {todo.work_order_id}</p>
                    </div>
                  </div>
                <br />
                <p>Name of the Department/Quarters No :{correspondingTable1Data.department}</p>
                <br></br>
                <p>The following works mentioned below may kindly be arranged to be undertaken</p>
                <br></br>
                      <p>{correspondingTable2Data.body}</p>
                      <br></br>
                      <br></br>
                      <br></br>
                      <br></br>
                      <br></br>
                      <div style={{ textAlign: 'right' , marginRight: '100px'}}>
                        {/* Replace 'nameValue', 'signatureValue', and 'deptNoValue' with the actual values */}
                  
                        <p>Designation: </p>
                      </div>
                      <br></br>
                      <hr></hr>
                      <br></br>
                      <h4 style={{fontWeight: 'bold', textAlign: 'center'}}>SUMMARY OF THE WORKS CARRIED OUT:</h4>
                      <TextField
                            label=""
                            fullWidth
                            multiline
                            rows={8}
                            variant="outlined"
                            margin="normal"
                        />
                      <br></br>
                      <br></br>
                      <br></br>
                      <br></br>
                      <br></br>
                      <br></br>
                      <p style={{fontWeight:'bold', textAlign: "right"}}>       Officer in-charge</p>
                      <p style={{fontWeight:'bold', textAlign: "right"}}>Refrigirator and air condirioning</p>
                      <br></br>
                      <hr></hr>
                      <br></br>
                      <p>Job completed satisfactorily on {workCompletionDate}</p>
                      <br></br>
                      <br></br>
                      <br></br>
                      <p style={{textAlign:"center"}}>Department {correspondingTable1Data.department}</p>
                    </div>
                  );
              }
            })}
            <br />
        </div>
      </div>
    </div>
    </Card>
  );
};

export default Print;
